[
  {
    "id": "ground-zero",
    "name": "Ground Zero",
    "nameJa": "グラウンドゼロ",
    "bounds": [
      [
        249,
        -124
      ],
      [
        -99,
        364
      ]
    ],
    "transform": [
      0.524,
      167.3,
      0.524,
      65.1
    ],
    "coordinateRotation": 180,
    "tileSize": 256,
    "minZoom": 1,
    "maxZoom": 6,
    "tilePath": "maps/groundzero/main_summer/{z}/{x}/{y}.png",
    "svgPath": "maps/svg/GroundZero.svg",
    "svgLayer": "Ground_Level",
    "layers": [
      {
        "name": "2nd Floor",
        "svgLayer": "Second_Floor",
        "tilePath": "maps/groundzero/2nd/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "3rd Floor",
        "svgLayer": "Third_Floor",
        "tilePath": "maps/groundzero/3rd/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Garage",
        "svgLayer": "Underground_Level",
        "tilePath": "maps/groundzero/garage/{z}/{x}/{y}.png",
        "show": false
      }
    ],
    "author": "Shebuka",
    "authorLink": "https://github.com/the-hideout/tarkov-dev-svg-maps/"
  },
  {
    "id": "customs",
    "name": "Customs",
    "nameJa": "カスタム",
    "bounds": [
      [
        698,
        -307
      ],
      [
        -372,
        237
      ]
    ],
    "transform": [
      0.239,
      168.65,
      0.239,
      136.35
    ],
    "coordinateRotation": 180,
    "tileSize": 256,
    "minZoom": 2,
    "maxZoom": 6,
    "tilePath": "maps/customs_0.16/main/{z}/{x}/{y}.png",
    "svgPath": "maps/svg/Customs.svg",
    "svgLayer": "Ground_Level",
    "layers": [
      {
        "name": "2nd Floor",
        "svgLayer": "Second_Floor",
        "tilePath": "maps/customs_0.16/2nd/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "3rd Floor",
        "svgLayer": "Third_Floor",
        "tilePath": "maps/customs_0.16/3rd/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "4th Floor",
        "tilePath": "maps/customs_0.16/4th/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Underground",
        "svgLayer": "Underground_Level",
        "tilePath": "maps/customs_0.16/underground/{z}/{x}/{y}.png",
        "show": false
      }
    ],
    "author": "Shebuka",
    "authorLink": "https://github.com/the-hideout/tarkov-dev-svg-maps/"
  },
  {
    "id": "factory",
    "name": "Factory",
    "nameJa": "ファクトリー",
    "bounds": [
      [
        77,
        -64.5
      ],
      [
        -65.5,
        67.4
      ]
    ],
    "transform": [
      1.629,
      119.9,
      1.629,
      139.3
    ],
    "coordinateRotation": 90,
    "tileSize": 256,
    "minZoom": 1,
    "maxZoom": 6,
    "tilePath": "maps/factory/main/{z}/{x}/{y}.png",
    "svgPath": "maps/svg/Factory.svg",
    "svgLayer": "Ground_Floor",
    "layers": [
      {
        "name": "2nd Floor",
        "svgLayer": "Second_Floor",
        "tilePath": "maps/factory/2nd/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "3rd Floor",
        "svgLayer": "Third_Floor",
        "tilePath": "maps/factory/3rd/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Tunnels",
        "svgLayer": "Basement",
        "tilePath": "maps/factory/tunnels/{z}/{x}/{y}.png",
        "show": false
      }
    ],
    "author": "Shebuka",
    "authorLink": "https://github.com/the-hideout/tarkov-dev-svg-maps/"
  },
  {
    "id": "woods",
    "name": "Woods",
    "nameJa": "ウッズ",
    "bounds": [
      [
        646,
        -914
      ],
      [
        -761,
        442
      ]
    ],
    "transform": [
      0.1855,
      112.95,
      0.1855,
      167.85
    ],
    "coordinateRotation": 180,
    "tileSize": 256,
    "minZoom": 2,
    "maxZoom": 6,
    "tilePath": "maps/woods/main_0.16/{z}/{x}/{y}.png",
    "svgPath": "maps/svg/Woods.svg",
    "svgLayer": "Ground_Level",
    "layers": [],
    "author": "Shebuka",
    "authorLink": "https://github.com/the-hideout/tarkov-dev-svg-maps/"
  },
  {
    "id": "interchange",
    "name": "Interchange",
    "nameJa": "インターチェンジ",
    "bounds": [
      [
        598,
        -442
      ],
      [
        -433,
        426
      ]
    ],
    "transform": [
      0.265,
      150.6,
      0.265,
      134.6
    ],
    "coordinateRotation": 180,
    "tileSize": 256,
    "minZoom": 1,
    "maxZoom": 6,
    "tilePath": "maps/interchange/main/{z}/{x}/{y}.png",
    "svgPath": "maps/svg/Interchange.svg",
    "svgLayer": "Ground_Level",
    "layers": [
      {
        "name": "2nd Floor",
        "svgLayer": "First_Floor",
        "show": true
      },
      {
        "name": "3rd Floor",
        "svgLayer": "Second_Floor",
        "show": false
      }
    ],
    "author": "Shebuka",
    "authorLink": "https://github.com/the-hideout/tarkov-dev-svg-maps/"
  },
  {
    "id": "shoreline",
    "name": "Shoreline",
    "nameJa": "ショアライン",
    "bounds": [
      [
        504,
        -415
      ],
      [
        -1056,
        618
      ]
    ],
    "transform": [
      0.16,
      83.2,
      0.16,
      111.1
    ],
    "coordinateRotation": 180,
    "tileSize": 256,
    "minZoom": 2,
    "maxZoom": 6,
    "tilePath": "maps/shoreline/main_summer/{z}/{x}/{y}.png",
    "svgPath": "maps/svg/Shoreline.svg",
    "svgLayer": "Ground_Level",
    "layers": [
      {
        "name": "2nd Floor",
        "svgLayer": "Second_Floor",
        "show": false
      },
      {
        "name": "3rd Floor",
        "svgLayer": "Third_Floor",
        "show": false
      },
      {
        "name": "Underground",
        "svgLayer": "Underground_Level",
        "show": false
      }
    ],
    "author": "Shebuka",
    "authorLink": "https://github.com/the-hideout/tarkov-dev-svg-maps/"
  },
  {
    "id": "reserve",
    "name": "Reserve",
    "nameJa": "リザーブ",
    "bounds": [
      [
        289,
        -293
      ],
      [
        -303,
        244
      ]
    ],
    "svgBounds": [
      [
        289,
        -274
      ],
      [
        -303,
        272
      ]
    ],
    "transform": [
      0.395,
      122,
      0.395,
      137.65
    ],
    "coordinateRotation": 180,
    "tileSize": 256,
    "minZoom": 2,
    "maxZoom": 6,
    "tilePath": "maps/reserve/main/{z}/{x}/{y}.png",
    "svgPath": "maps/svg/Reserve.svg",
    "svgLayer": "Ground_Level",
    "layers": [
      {
        "name": "2nd Floor",
        "tilePath": "maps/reserve/2nd/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "3rd Floor",
        "tilePath": "maps/reserve/3rd/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "4th Floor",
        "tilePath": "maps/reserve/4th/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "5th Floor",
        "tilePath": "maps/reserve/5th/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Bunkers",
        "svgLayer": "Bunkers",
        "tilePath": "maps/reserve/bunkers/{z}/{x}/{y}.png",
        "show": false
      }
    ],
    "author": "Shebuka",
    "authorLink": "https://github.com/the-hideout/tarkov-dev-svg-maps/"
  },
  {
    "id": "lighthouse",
    "name": "Lighthouse",
    "nameJa": "ライトハウス",
    "bounds": [
      [
        515,
        -998
      ],
      [
        -545,
        725
      ]
    ],
    "transform": [
      0.2,
      0,
      0.2,
      0
    ],
    "coordinateRotation": 180,
    "tileSize": 256,
    "minZoom": 1,
    "maxZoom": 6,
    "svgPath": "maps/svg/Lighthouse.svg",
    "svgLayer": "Ground_Level",
    "layers": [],
    "author": "Shebuka",
    "authorLink": "https://github.com/the-hideout/tarkov-dev-svg-maps/"
  },
  {
    "id": "streets-of-tarkov",
    "name": "Streets of Tarkov",
    "nameJa": "ストリート",
    "bounds": [
      [
        323,
        -295
      ],
      [
        -280,
        532
      ]
    ],
    "transform": [
      0.38,
      0,
      0.38,
      0
    ],
    "coordinateRotation": 180,
    "tileSize": 256,
    "minZoom": 1,
    "maxZoom": 5,
    "svgPath": "maps/svg/StreetsOfTarkov.svg",
    "svgLayer": "Ground_Level",
    "layers": [
      {
        "name": "2nd Floor",
        "svgLayer": "Second_Floor",
        "show": false
      },
      {
        "name": "3rd Floor",
        "svgLayer": "Third_Floor",
        "show": false
      },
      {
        "name": "4th Floor",
        "svgLayer": "Fourth_Floor",
        "show": false
      },
      {
        "name": "5th Floor",
        "svgLayer": "Fifth_Floor",
        "show": false
      },
      {
        "name": "Underground",
        "svgLayer": "Underground_Level",
        "show": false
      }
    ],
    "author": "Shebuka",
    "authorLink": "https://github.com/the-hideout/tarkov-dev-svg-maps/"
  },
  {
    "id": "terminal",
    "name": "Terminal",
    "nameJa": "ターミナル",
    "bounds": [
      [
        463,
        -580
      ],
      [
        -433,
        475
      ]
    ],
    "transform": [
      0.2,
      0,
      0.2,
      0
    ],
    "coordinateRotation": 180,
    "tileSize": 256,
    "minZoom": 2,
    "maxZoom": 6,
    "svgPath": "maps/svg/Terminal.svg",
    "svgLayer": "Ground_Level",
    "layers": [],
    "author": "Shebuka",
    "authorLink": "https://github.com/the-hideout/tarkov-dev-svg-maps/"
  },
  {
    "id": "the-lab",
    "name": "The Lab",
    "nameJa": "ラボ",
    "bounds": [
      [
        -80,
        -477
      ],
      [
        -287,
        -193
      ]
    ],
    "transform": [
      0.575,
      281.2,
      0.575,
      193.7
    ],
    "coordinateRotation": 270,
    "tileSize": 175,
    "minZoom": 2,
    "maxZoom": 6,
    "tilePath": "maps/labs_v4/1st/{z}/{x}/{y}.png",
    "layers": [
      {
        "name": "Second Level",
        "tilePath": "maps/labs_v4/2nd/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Technical",
        "tilePath": "maps/labs_v4/technical/{z}/{x}/{y}.png",
        "show": false
      }
    ],
    "author": "Tarkov.dev",
    "authorLink": "https://tarkov.dev"
  },
  {
    "id": "the-labyrinth",
    "name": "The Labyrinth",
    "nameJa": "ラビリンス",
    "bounds": [
      [
        -52,
        -37
      ],
      [
        53,
        76
      ]
    ],
    "transform": [
      2.115,
      85.5,
      2.115,
      128
    ],
    "coordinateRotation": 270,
    "tileSize": 256,
    "minZoom": 1,
    "maxZoom": 6,
    "tilePath": "maps/labyrinth/main/{z}/{x}/{y}.png",
    "layers": [],
    "author": "Tarkov.dev",
    "authorLink": "https://tarkov.dev"
  },
  {
    "id": "icebreaker",
    "name": "Icebreaker",
    "nameJa": "アイスブレーカー",
    "bounds": [
      [
        77,
        -64.5
      ],
      [
        -65.5,
        67.4
      ]
    ],
    "transform": [
      2,
      125,
      3.5,
      91
    ],
    "coordinateRotation": 180,
    "tileSize": 256,
    "minZoom": 1,
    "maxZoom": 5,
    "tilePath": "maps/icebreaker/06_infirmary/{z}/{x}/{y}.png",
    "layers": [
      {
        "name": "Infirmary",
        "tilePath": "maps/icebreaker/06_infirmary/{z}/{x}/{y}.png",
        "show": true
      },
      {
        "name": "Helipad",
        "tilePath": "maps/icebreaker/07_helipad/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Gym/Canteen",
        "tilePath": "maps/icebreaker/08_gym-canteen/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Accommodation (lower)",
        "tilePath": "maps/icebreaker/09_accommodation_lower/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Accommodation (mid)",
        "tilePath": "maps/icebreaker/10_accommodation_mid/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Accommodation (upper)",
        "tilePath": "maps/icebreaker/11_accommodation_upper/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Officers' Deck",
        "tilePath": "maps/icebreaker/12_officers_deck/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Stairs (blocked)",
        "tilePath": "maps/icebreaker/13_stairs_blocked/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Bridge",
        "tilePath": "maps/icebreaker/14_bridge/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Bridge Roof",
        "tilePath": "maps/icebreaker/15_bridge_roof/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Control Room",
        "tilePath": "maps/icebreaker/00_control_room/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Engine Room",
        "tilePath": "maps/icebreaker/01_engine_room/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Engine Room (upper)",
        "tilePath": "maps/icebreaker/02_engine_room_upper/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Fuel Pumps (lower)",
        "tilePath": "maps/icebreaker/03_fuel_pumps_lower/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Fuel Pumps",
        "tilePath": "maps/icebreaker/04_fuel_pumps/{z}/{x}/{y}.png",
        "show": false
      },
      {
        "name": "Storage/Security",
        "tilePath": "maps/icebreaker/05_storage_ecurity/{z}/{x}/{y}.png",
        "show": false
      }
    ],
    "author": "TarkovBOT.eu",
    "authorLink": "https://tarkovbot.eu/"
  }
]
